import { BRAND } from "@/lib/siteData";

/**
 * A small centered BRM emblem used as a tasteful section motif —
 * stands in for the hard horizontal divider lines we removed.
 *
 * Props:
 *   size: "sm" | "md" | "lg"  default "md"
 *   className: extra wrapper classes
 */
export default function EmblemMotif({ size = "md", className = "" }) {
  const heightCls =
    size === "sm" ? "h-10 md:h-12" : size === "lg" ? "h-20 md:h-24" : "h-14 md:h-16";
  return (
    <div
      className={`flex items-center justify-center ${className}`}
      aria-hidden="true"
      data-testid={`emblem-motif-${size}`}
    >
      <img
        src={BRAND.emblemUrl}
        alt=""
        className={`${heightCls} w-auto opacity-90 select-none pointer-events-none`}
      />
    </div>
  );
}
